import React from 'react';
import { ItemDelegate } from '@leverege/molten/imagine';
import BillingPortalScreen from './BillingPortalScreen';
function processRelationship(molten, relationship, options) {
  const {
    blueprint,
    path,
    objectType,
    attribute
  } = relationship;
  const urlPath = attribute?.isOneToOne() ? `${relationship.urlPath}/info` : `${relationship.urlPath}/:${blueprint.type}Id/billingPortal`;
  if (blueprint.type === 'location') {
    molten.addPlugin('Route', {
      id: `recovr.${path}.BillingPortalScreen`,
      matches: {
        objectType,
        path
      },
      exact: true,
      path: urlPath,
      render: ({
        match,
        ...rest
      }) => {
        const resourceId = attribute?.isOneToOne() ? attribute.path : match.params[`${blueprint.type}Id`];
        const iRel = relationship.createItem(match, resourceId);
        const props = {
          match,
          ...rest,
          relationship: iRel,
          resourceId,
          objectType: attribute?.blueprint.type || blueprint.type,
          actions: new ItemDelegate({
            match,
            relationship: iRel,
            id: resourceId
          }) // TODO ITEM ACTIONS
        };
        return /*#__PURE__*/React.createElement(BillingPortalScreen, props);
      }
    });
  }
}
export default {
  id: 'recovr.BillingPortalScreenRouteCreator',
  type: 'recovr.BillingPortalScreenRouteCreator',
  processRelationship
};